/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import urljoin from 'url-join';
import io, { Socket } from 'socket.io-client';
import { getBaseUrl } from 'services/env-service';
import { getUserToken } from 'services/token';
import { useSelector } from 'react-redux';
import { getIsUserLoggedIn } from 'store/selectors/auth';

let CONNECTION_COUNT = 0;

const socket = io(
  urljoin(
    getBaseUrl()
      .replace('/api', '')
      .replace('http', 'ws'),
  ),
  {
    transports: ['websocket'],
    autoConnect: false,
    path: '/api/socket',
    auth: cb => cb({ token: getUserToken() }),
  },
);

const connect = () => {
  CONNECTION_COUNT++;
  if (!socket.connected) socket.connect();
};

const disconnect = () => --CONNECTION_COUNT <= 0 && socket.disconnect();

export const useSocket = (): Socket => {
  const isLoggedIn = useSelector(getIsUserLoggedIn);

  useEffect(() => {
    if (isLoggedIn) connect();

    return () => {
      if (isLoggedIn) disconnect();
    };
  }, [isLoggedIn]);

  return socket;
};
